/**
 * Fan favorites: Swiper carousel with mobile segment pagination (viral-video-showcase pattern).
 */
(function () {
  function initFanFavorites(root) {
    if (typeof Swiper === 'undefined') return;

    var slideCount = parseInt(root.getAttribute('data-slide-count'), 10) || 0;
    if (slideCount < 1) return;

    var swiperEl = root.querySelector('.fan-favorites__swiper');
    var prevBtn = root.querySelector('.fan-favorites__nav--prev');
    var nextBtn = root.querySelector('.fan-favorites__nav--next');
    var bullets = Array.prototype.slice.call(root.querySelectorAll('.fan-favorites__pagination-bullet'));

    if (!swiperEl) return;

    function updatePagination(swiper) {
      if (!bullets.length) return;
      var realIdx = swiper.realIndex % slideCount;
      bullets.forEach(function (b, i) {
        b.classList.toggle('is-active', i === realIdx);
      });
    }

    var VISIBLE_CLASS = 'is-visible-slide';

    /** Ensures is-visible-slide is applied; Swiper sometimes skips internal toggle before layout/breakpoints. */
    function syncVisibleSlideClasses(swiper) {
      swiper.updateSlidesProgress(swiper.translate);
      var slides = swiper.slides;
      var vis = swiper.visibleSlides || [];
      if (vis.length === 0 && slides.length > 0) {
        var rr = swiper.el.getBoundingClientRect();
        vis = [];
        for (var j = 0; j < slides.length; j++) {
          var sr = slides[j].getBoundingClientRect();
          if (sr.right > rr.left && sr.left < rr.right) {
            vis.push(slides[j]);
          }
        }
      }
      for (var i = 0; i < slides.length; i++) {
        slides[i].classList.remove(VISIBLE_CLASS);
      }
      for (i = 0; i < vis.length; i++) {
        vis[i].classList.add(VISIBLE_CLASS);
      }
    }

    new Swiper(swiperEl, {
      loop: slideCount > 4,
      slidesPerView: 1.32,
      spaceBetween: 20,
      speed: 400,
      grabCursor: true,
      watchOverflow: true,
      watchSlidesProgress: true,
      slideVisibleClass: 'is-visible-slide',
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      breakpoints: {
        744: {
          slidesPerView: 2.39,
          spaceBetween: 20,
          watchSlidesProgress: true,
          slideVisibleClass: 'is-visible-slide',
        },
        1024: {
          slidesPerView: 3.1,
          spaceBetween: 32,
          watchSlidesProgress: true,
          slideVisibleClass: 'is-visible-slide',
        },
      },
      on: {
        afterInit: function (swiper) {
          swiper.update();
          syncVisibleSlideClasses(swiper);
          requestAnimationFrame(function () {
            syncVisibleSlideClasses(swiper);
          });
          updatePagination(swiper);
        },
        slideChange: function (swiper) {
          syncVisibleSlideClasses(swiper);
        },
        slideChangeTransitionEnd: function (swiper) {
          syncVisibleSlideClasses(swiper);
          updatePagination(swiper);
        },
        resize: function (swiper) {
          syncVisibleSlideClasses(swiper);
        },
        breakpoint: function (swiper) {
          syncVisibleSlideClasses(swiper);
        },
      },
    });
  }

  function initAll() {
    document.querySelectorAll('[data-fan-favorites]').forEach(function (root) {
      initFanFavorites(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
